import { observable, computed, action } from "mobx";
import Autobind from "autobind-decorator";
import RootStore from "./rootStore";
import LicenseValidator from "core/license/licenseValidator";
import Config from "config";
import _ from "lodash";
/**
 * @class LicenseStore
 * @description License 상태 정보 제어
 */
@Autobind
class LicenseStore {
  _rootStore: RootStore; /// rootStore 객체. 다른 Store를 연계할 때 사용
  _licenseValidator: LicenseValidator;

  @observable _valid: boolean = true;

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;
    const expirationDate = _.get(Config, "license.expirationDate", "");

    this._licenseValidator = new LicenseValidator();
    this._licenseValidator.usePolicy("DatePolicy", { expirationDate });

    // 프로그램 구동시 라이선스 검증
    this.verify();
  }

  verify() {
    this._licenseValidator.verify().then((value) => {
      this._valid = !!value;
    });
  }

  getValidity() {
    return this._valid;
  }
}

export default LicenseStore;
